
import { defineComponent, PropType } from 'vue'
import RoleAccessMixin from '~/mixins/roleAccessMixin'
import { SilenceRule } from '~/types/types'
import { fromNow } from '~/utils/date'

export default defineComponent({
  name: 'IgnoredRule',
  mixins: [RoleAccessMixin],
  props: {
    rule: {
      type: Object as PropType<SilenceRule>,
      required: true
    },
    verticalPadding: {
      type: String,
      default: 'py-4'
    }
  },
  computed: {
    allowDelete(): boolean {
      return this.loggedIn && this.repoPerms.canIgnoreIssues
    },
    ruleCreatedTime(): string {
      return fromNow(this.rule.createdAt)
    }
  }
})
